// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/PrivacyAndTerms/style.css
// module id = 2829
// module chunks = 29